var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('sub-title',{staticClass:"title",attrs:{"title":"服务优势"}}),_vm._v(" "),_c('div',{staticClass:"all-service-card"},_vm._l((_vm.serviceCardList),function(item,index){return _c('service-card',{key:index,attrs:{"need-obj":item}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }